<template>
  <div class="users">
    <div class="container">
      <div class="float-right">
        <button
          type="button"
          class="btn btn-primary waves-effect"
          data-toggle="modal"
          data-target="#userForm"
        >
          <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add User
        </button>
      </div>
      <div class="clearfix"></div>

      <div class="card">
        <div class="card-header blue-gradient text-white">
          <h3>Users</h3>
        </div>
        <div class="card-body table-responsive">
          <!-- <div class="float-right form-inline">
            <div class="form-group">
              <label for="filterby">Filter By : </label>
              <select class="form-control" id="filterby">
                <option>Admins</option>
                <option>Mechanic</option>
                <option>Customer</option>
              </select>
            </div>
          </div> -->
          <div class="clearfix"></div>
          <table class="table" id="example">
            <thead>
              <tr>
                <th>#</th>
                <th>Profile</th>
                <th>Fullname</th>
                <th>Email</th>
                <th>Address</th>
                <th data-mdb-toggle="tooltip" title="Social Security Number">
                  Ssn
                </th>
                <th>Type</th>
                <th>actions</th>
              </tr>
            </thead>
            <tbody v-if="users.length > 0">
              <tr v-for="(item, index) in users" :key="item._id">
                <td scope="row">{{ index }}</td>
                <td>
                  <img
                    :src="item.profile"
                    class="rounded-circle img-responsive img-responsive"
                    style="width: 50px"
                    :alt="item.firstname"
                  />
                </td>
                <td scope="row">{{ item.firstname + " " + item.lastname }}</td>
                <td scope="row">{{ item.email }}</td>
                <td v-if="item.addrress">No address</td>
                <td v-else>{{ item.address }}</td>
                <td>
                  <span v-if="item.ssn">{{ ssn }}</span>
                  <span v-else>Not set</span>
                </td>
                <td>
                  <span
                    :class="[
                      'badge',
                      'badge-pill',
                      'badge-' + setPillColor(item.role),
                    ]"
                    >{{ item.role }}</span
                  >
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm tetx-white"
                    data-toggle="modal"
                    data-target="#userForm"
                    @click="updateUser(item._id, index)"
                  >
                    <i class="fa fa-pen" aria-hidden="true"></i>
                  </button>

                  <button
                    type="button"
                    class="btn btn-danger btn-sm tetx-white"
                    @click="deleteUser(item._id)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-if="!loading">
                <td colspan="4" class="text-center">No item available</td>
              </tr>
              <tr v-else>
                <td colspan="4" class="text-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Add User -->
      <div
        class="modal fade"
        id="userForm"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modelTitleId"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add User</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form method="post" enctype="application/x-www-form-urlencoded">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <!-- FirstName -->
                    <div class="md-form">
                      <input
                        type="text"
                        id="firstname"
                        v-model.trim="form.firstname"
                        class="form-control"
                      />
                      <label for="firstname">Firstname</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- lastName -->
                    <div class="md-form">
                      <input
                        type="text"
                        id="lastname"
                        v-model.trim="form.lastname"
                        class="form-control"
                      />
                      <label for="lastname">Lastname</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- Email -->
                    <div class="md-form">
                      <input
                        type="email"
                        id="email"
                        v-model.trim="form.email"
                        class="form-control"
                      />
                      <label for="email">Email</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- Password -->
                    <div class="md-form position-relative">
                      <input
                        :type="[!eye ? 'password' : 'text']"
                        id="password"
                        v-model.trim="form.password"
                        class="form-control"
                      />
                      <span class="eye" @click="eyeToggle"
                        ><i
                          :class="['fa', !eye ? 'fa-eye' : 'fa-eye-slash']"
                          aria-hidden="true"
                        ></i
                      ></span>
                      <label for="password">Password</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- Address -->
                    <div class="md-form">
                      <input
                        type="text"
                        id="address"
                        v-model.trim="form.address"
                        class="form-control"
                      />
                      <label for="address">Address</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- social security number -->
                    <div class="md-form">
                      <input
                        type="text"
                        id="social-security-number"
                        class="form-control"
                        v-model.trim="form.ssn"
                      />
                      <span class="text-muted text-danger" v-if="!res">
                        Social Security Number non valid
                      </span>
                      <label for="social-security-number"
                        >Social Security Number</label
                      >
                    </div>
                  </div>
                  <!-- role -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="filterby">Filter By : </label>
                      <select
                        class="form-control"
                        v-model.trim="form.role"
                        id="filterby"
                      >
                        <option value="admin" selected>Admin</option>
                        <option value="mechanic">Mechanic</option>
                        <option value="customer">Customer</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- UserProfile -->
                    <div class="input-group mb-2">
                      <label for="user-upload">Profile: </label>
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="showcase-file"
                          >Upload</span
                        >
                      </div>
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="user-upload"
                          ref="file"
                          aria-describedby="user-file"
                        />
                        <label class="custom-file-label" for="user-upload"
                          >Choose Image</label
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Save button -->
                <button
                  class="
                    btn btn-outline-info btn-rounded btn-block
                    z-depth-0
                    my-4
                    waves-effect
                  "
                  type="button"
                  @click="createUser()"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<style lang="scss" scope>
span.eye {
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;
}
</style>

<script>
import axios from "axios";
import { auth } from "@/firebase";
// import $ from "jquery";
import swal from "sweetalert";

export default {
  data() {
    return {
      users: [],
      form: {
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        address: "",
        ssn: "",
        role: "admin",
      },
      error: {
        errorCode: "",
        errorMessage: "",
      },
      loading: true,
      eye: false,
      ssn: "",
      res: true,
    };
  },
  methods: {
    fetchUsers() {
      axios
        .get("http://127.0.0.1:3000/api/users?limit=1000", this.options)
        .then((response) => {
          this.users = response.data[1].data;
          this.loading = false;
          if (typeof window.$.fn.DataTable != "undefined") {
            window.$(document).ready(function () {
              window.$("#example").DataTable();
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setPillColor(type) {
      switch (type) {
        case "admin":
          return "success";
        case "mechanic":
          return "primary";
        case "customer":
          return "info";
        default:
          return "danger";
      }
    },
    eyeToggle() {
      this.eye = !this.eye;
    },
    createUser() {
      this.resetError();
      auth
        .createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then((userCredentiels) => {
          var user = userCredentiels.user;
          axios
            .post("/api/users", {
              id: user.uid,
              firstname: this.form.firstname,
              lastname: this.form.lastname,
              email: user.email,
              password: this.form.password,
              address: this.form.address,
              role: this.form.role,
            })
            .then((response) => {
              console.log("user created response", response);
            })
            .catch((err) => {
              console.log(err);
            });
          console.log("user created", user);
        })
        .catch((error) => {
          this.error.errorCode = error.code;
          this.error.errorMessage = error.message;
        });
    },
    // fetchUserPerId(id) {
    //   axios
    //     .get("https://localhost:3000/api/users/" + auth.currentUser.uid)
    //     .then((response) => {})
    //     .catch((error) => {});
    // },
    resetError() {
      this.error.errorCode = "";
      this.error.errorMessage = "";
    },
    deleteUser(id) {
      var self = this;
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          console.log(id);
          axios
            .delete("http://127.0.0.1:3000/api/users/" + id)
            .then((response) => {
              console.log(response);
              self.users = self.users.filter((e) => e["_id"] != id);
              swal("Poof! Your user has been deleted!", {
                icon: "success",
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          swal("Your user is safe!");
        }
      });
    },
  },
  watch: {
    "form.ssn": function (val) {
      const ssnPattern = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
      this.res = ssnPattern.test(val);
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>